import { Action } from 'redux';

import { RemoveFromThisCollection } from '../../bootstrap/redux/actions/AppActionTypes';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';

export interface RemoveFromThisCollectionAction extends Action {
  targetItems: IContentInfo[];
}

export function removeFromThisCollectionAction(targetItems: IContentInfo[]): RemoveFromThisCollectionAction {
  return {
    type: RemoveFromThisCollection,
    targetItems: targetItems,
  };
}
